/**
 * @description 前台 Service 层
 * http://test.convention-docs.shuwen.com/swagger-ui.html#/
 */

 import {normalizeResult} from '@/utils/tool';
 import request from '@/utils/request';
 
 const baseUrl = '/api/v1';
 
 export interface IGetFileList {
   columnType: 'banner' | 'document' | 'news';
 }
 
 // 获取议程详情
 export async function getActivityScheduleDetail(id: string) {
   const res = await request(`${baseUrl}/activity-schedule/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询议程
 export async function getActivityScheduleList() {
   const res = await request(`${baseUrl}/activity-schedule/list`, {
     method: 'POST',
     body: {
       status: 1,
     },
   });
   return normalizeResult<any>(res);
 }
 
 // 获取专题视频详情
 export async function getActivityDetail(id: string | number) {
   const res = await request(`${baseUrl}/activity/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 
 // 获取论坛详情
 export async function getBbsDetail(id: string) {
   if(id){
     const res = await request(`${baseUrl}/bbs/${id}`, {
       method: 'GET',
     });
     return normalizeResult<any>(res);
   }
 }
 
 // 查询论坛
 export async function getBbsList(type: string) {
   const res = await request(`${baseUrl}/bbs/list`, {
     method: 'POST',
     body: {
       status: 1,
       type: type
     },
   });
   return normalizeResult<any>(res);
 }
 
 // 获取素材详情
 export async function getMediaDetail(id: string) {
   const res = await request(`${baseUrl}/media/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询素材
 export async function getMediaList(data: IGetFileList) {
   const res = await request(`${baseUrl}/media/list`, {
     method: 'POST',
     body: {...data, status: 1},
   });
   return normalizeResult<any>(res);
 }
 
 // 获取直播详情
 export async function getMiceDetail(id: string) {
   const res = await request(`${baseUrl}/mice/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询直播
 export async function getMiceList() {
   const res = await request(`${baseUrl}/mice/list`, {
     method: 'POST',
     body: {
       status: 1,
     },
   });
   return normalizeResult<any>(res);
 }
 
 // 获取专题详情
 export async function getTopicDetail(id: string) {
   const res = await request(`${baseUrl}/topic/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 获取专题详情
 export async function getTopicRecommend(id: string) {
   const res = await request(`${baseUrl}/activity/recommend/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询专题
 export async function getTopicList() {
   const res = await request(`${baseUrl}/topic/list`, {
     method: 'POST',
     body: {
       status: 1,
     },
   });
   return normalizeResult<any>(res);
 }
 
 export interface IActivityListItem {
   "current": number,
   "size": number,
   "query": {
     "dictValue": string | number | undefined,
     "topicId": number | string,
     "status": number
   }
 }
 
 // 查询专题视频
 export async function getActivityList(data:IActivityListItem) {
   const res = await request(`${baseUrl}/activity/page`, {
     method: 'POST',
     body: data,
   });
   return normalizeResult<any>(res);
 }
 
 // 查询专题视频
 export async function getHomeActivityList(data: {topicId: string}) {
   const res = await request(`${baseUrl}/home/activity/list`, {
     method: 'POST',
     body: { ...data, status: 1 },
   });
   return normalizeResult<any>(res);
 }
 
 // 获取嘉宾详情
 export async function getVipUserDetail(id: string) {
   const res = await request(`${baseUrl}/vip-user/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询嘉宾
 export async function getVipUserList() {
   const res = await request(`${baseUrl}/vip-user/list`, {
     method: 'POST',
     body: {
       status: 1,
     },
   });
   return normalizeResult<any>(res);
 }
 
 // 获取展位
 export async function getBoothDetail(id: string) {
   const res = await request(`${baseUrl}/booth/${id}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询展位
 export async function getBoothList() {
   const res = await request(`${baseUrl}/booth/list`, {
     method: 'POST',
     body: {
       status: 9,
     },
   });
   return normalizeResult<any>(res);
 }
 
 // 查询展位
 export async function wonderfulList() {
   const res = await request(`${baseUrl}/bbs/wonderful/list`, {
     method: 'get',
   });
   return normalizeResult<any>(res);
 }
 
 // 分页查询主题日活动和地方活动
 export async function getMedia({current, size ,...rest}: {
   current: number
   size: number
   columnType: string;
   dictValue?: string;
 }) {
   const res = await request(`${baseUrl}/media/page`, {
     method: 'POST',
     body: {
       current,
       size,
       query: rest
     }
   });
   return normalizeResult<any>(res);
 }
 
 
 
 // 字典查询
 export async function getDict(dictTypeValue: string) {
   const res = await request(`${baseUrl}/dict/value/${dictTypeValue}`, {
     method: 'GET',
   });
   return normalizeResult<any>(res);
 }
 
 // 查询云课堂分类
 export async function getTopicClass() {
   const res = await request(`${baseUrl}/dict/value/onlineCourseType`, {
     method: 'get',
   });
   return normalizeResult<any>(res);
 }
 
 
 
 // 获取点赞数
 export async function getLike(businessType: number, businessId: string) {
   const res = await request(`${baseUrl}/like/${businessType}/${businessId}`, {
     method: 'get',
   });
   return normalizeResult<any>(res);
 }
 
 // 点赞
 export async function like(businessType: number, businessId: string) {
   const res = await request(`${baseUrl}/like/${businessType}/${businessId}`, {
     method: 'POST',
     body: {}
   });
   return normalizeResult<any>(res);
 }
 